module.exports = __webpack_public_path__ + "img/menu_s_1.2cc40060.png";